"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScanLines = void 0;
const react_1 = require("@chakra-ui/react");
const lodash_1 = require("lodash");
const react_2 = __importStar(require("react"));
const hooks_1 = require("../hooks");
const colors_1 = require("../utils/colors");
const ScanLines = (_a) => {
    var { numLines, borderColor: outsideBorderColor } = _a, props = __rest(_a, ["numLines", "borderColor"]);
    const { primaryColor } = (0, hooks_1.usePrimaryColor)();
    const borderColor = (0, react_2.useMemo)(() => outsideBorderColor !== null && outsideBorderColor !== void 0 ? outsideBorderColor : (0, colors_1.alphaColor)(primaryColor, 0.3), [outsideBorderColor, primaryColor]);
    return (react_2.default.createElement(react_1.Flex, Object.assign({ position: "absolute", top: 0, bottom: 0, left: 0, right: 0, borderRadius: "4px", justifyContent: "space-between", flexDirection: "column" }, props), (0, lodash_1.range)(numLines !== null && numLines !== void 0 ? numLines : 10).map((value, index) => {
        return (react_2.default.createElement(react_1.Box, { key: index, width: "full", borderTopWidth: "1px", borderTopStyle: "solid", borderTopColor: borderColor }));
    })));
};
exports.ScanLines = ScanLines;
//# sourceMappingURL=ScanLines.js.map